interface MeterTypeIconProps {
  type: string;
  className?: string;
}

export default function MeterTypeIcon({ type, className = 'w-5 h-5' }: MeterTypeIconProps) {
  if (type === 'GroundwaterSensorAsset') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" className={className}>
        <title>Water meter</title>
        <path d="M32 8 C32 8 14 28 14 40 C14 50.5 22 58 32 58 C42 58 50 50.5 50 40 C50 28 32 8 32 8 Z" fill="none" stroke="#5CB8B2" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round"/>
      </svg>
    );
  }

  // Default: electricity (lightning bolt)
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" className={className}>
      <title>Electricity meter</title>
      <defs>
        <linearGradient id="boltGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FBBF24"/>
          <stop offset="100%" stopColor="#F59E0B"/>
        </linearGradient>
      </defs>
      <path d="M38 4 L16 34 L28 34 L24 60 L48 28 L36 28 Z" fill="url(#boltGrad)" stroke="#D97706" strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  );
}
